import { ConvertedImageRaw } from '../../types';

import { ChallengeSaveError } from '../../../types';

import { createCoreMethod } from '../../utils/createCoreMethod';
import { getImageForNode } from '../../utils/getImageForNode';
import { isNodeWithSize } from '../../utils/isNodeWithSize';
import { shallowFindInContainer } from '../../utils/shallowFind';

/**
 * nodeContentOnly - determining whether other layers overlapping with node will be exported (or partially exported)
 */
export const getPartialNodeImage = createCoreMethod(
  'getPartialNodeImage',
  async (nodeId: string): Promise<ConvertedImageRaw | ChallengeSaveError> => {
    const tempLayer: FrameNode | null = figma.currentPage.children.find(
      (node) => node.name === 'velocity-temp-data' && node.type === 'FRAME'
    ) as FrameNode | null;

    if (!tempLayer) {
      return { type: 'NODE_NOT_FOUND' };
    }

    const node: BaseNode | null = shallowFindInContainer(nodeId, tempLayer);

    if (!node || !isNodeWithSize(node)) {
      return { type: 'NODE_NOT_FOUND' };
    }

    try {
      const result = await getImageForNode(node, true);

      if ('converted' in result) {
        return { converted: result.converted.take() };
      }

      return result;
    } catch {
      return { type: 'NODE_NOT_FOUND', nodeId: node.id, nodeName: node.name };
    }
  }
);
